import { render, staticRenderFns } from "./resend-to-sap.vue?vue&type=template&id=0061da30&"
import script from "./resend-to-sap.vue?vue&type=script&lang=js&"
export * from "./resend-to-sap.vue?vue&type=script&lang=js&"
import style0 from "./resend-to-sap.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports